var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageContent"},[_c('add',{ref:"add",attrs:{"IsShow":2,"LM":true},on:{"setConfig":_vm.setConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }